// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"robot-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M6 8C6 5.79086 7.79086 4 10 4H14C16.2091 4 18 5.79086 18 8C18 10.2091 16.2091 12 14 12H10C7.79086 12 6 10.2091 6 8Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19.5 21V19.5C19.5 17.2909 17.7091 15.5 15.5 15.5H8.5C6.29086 15.5 4.5 17.2909 4.5 19.5V21M12 4V2M10 12H14C16.2091 12 18 10.2091 18 8C18 5.79086 16.2091 4 14 4H10C7.79086 4 6 5.79086 6 8C6 10.2091 7.79086 12 10 12ZM10.25 8C10.25 8.13807 10.1381 8.25 10 8.25C9.86193 8.25 9.75 8.13807 9.75 8C9.75 7.86193 9.86193 7.75 10 7.75C10.1381 7.75 10.25 7.86193 10.25 8ZM14 8.25C13.8619 8.25 13.75 8.13807 13.75 8C13.75 7.86193 13.8619 7.75 14 7.75C14.1381 7.75 14.25 7.86193 14.25 8C14.25 8.13807 14.1381 8.25 14 8.25Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Robot1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'robot-1',
    ref,
    icon: element,
  },
));

Robot1Icon.displayName = 'Robot1Icon';

export default Robot1Icon;
